import script from "./MakerCartGuide9Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide9Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide9Page.vue?vue&type=style&index=0&id=b0257e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0257e4e"]])

export default __exports__